module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1508-e798edcacc96bed7cae37e30fbb030ee.png";